import { Observable } from 'rxjs';
import { PromotionRepository } from '../respository/promotion.repository';
import { UseCase } from '@/core/base/use-case';

export class GetPromotionsUseCase implements UseCase<any, any> {
    constructor(private readonly repository: PromotionRepository) {}

    execute(): Observable<any> {
        return this.repository.getPromotions();
    }
}
